import {Badge, BadgeProps} from '@chakra-ui/react';

interface NoexportBadgeProps extends BadgeProps {
    /** Only show "ne" instead of "noexport". */
    shortened?: boolean;
}

/** Marks a noexport folder. */
export function NoexportBadge({shortened = false, ...props}: NoexportBadgeProps) {
    return <Badge variant="solid" colorPalette="orange" size="sm" title="Nem exportálandó mappa" {...props}>
        {shortened ? "ne" : "noexport"}
    </Badge>;
}
